<template>
  <div>
    <h1 class="show-in-mobile">Recordatorios</h1>
    <div class="filter-container" style="margin-bottom:10px; text-align:left">
      <el-row>
        <el-col :xs="24" :sm="8" :md="6" :lg="6" :xl="4"  class="filter-col">
          <span style="margin-right: 10px">Filtrar</span>
          <el-input
            v-model="search"
            size="mini"
            placeholder="Nombre"
            style="width: 160px; margin-right:5px"
          />
        </el-col>
        <el-col :xs="24" :sm="8" :md="6" :lg="6" :xl="4" class="filter-col">
          <el-date-picker
            v-model="dateFilter"
            type="daterange"
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
            size="mini"
            range-separator="al"
            start-placeholder="Desde"
            end-placeholder="Hasta">
          </el-date-picker>
        </el-col>
        <el-col :xs="24" :sm="8" :md="6" :lg="6" :xl="4" class="filter-col">
          <el-button
            class="filter-item"
            type="primary"
            icon="el-icon-download"
            size="mini"
            @click="handleDownload"
            :loading="loadingExportButton"
            style="margin-left:20px"
          >Exportar
          </el-button>
        </el-col>
      </el-row>
    </div>
    <el-table
      v-loading="loading"
      element-loading-text="Cargando..."
      :data="reminderList.filter(data => {
        if( !dateFilter || (data.date >= dateFilter[0] && data.date <= dateFilter[1]))
          if(!search || data.client_name.toLowerCase().includes(searchInLowerCase) || data.client_business.toLowerCase().includes(searchInLowerCase) )
            return true
      })"
      ref="reminderListFiltered"
      :default-sort="{prop: 'date', order: 'ascending'}"
      style="width: 100%"
    >
      <el-table-column label="Fecha" prop="date" sortable min-width="100">
        <template slot-scope="scope">
          <span :class="scope.row.date_class">{{scope.row.date_text}}</span>
        </template>
      </el-table-column>
      <el-table-column label="Generador" prop="client_name" sortable min-width="200"></el-table-column>
      <el-table-column label="Razón Social" prop="client_business" sortable min-width="200"></el-table-column>
      <el-table-column 
        label="Tipo de residuo" 
        min-width="150"
        :filters="options"
        :filter-method="filterTrashType"
        filter-placement="bottom-end"
      >
        <template slot-scope="scope">
          {{scope.row.trash_type_t}}
        </template>
      </el-table-column>
      <el-table-column align="right" min-width="80">
        <template slot-scope="scope">
          <el-button
            v-if="hasPermission('all')"
            size="mini"
            type="danger"
            @click="handleDelete(scope.row)"
            icon="el-icon-delete"
          />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dateFilter: '',
      loading: false,
      loadingExportButton: false,
      search: "",
      modal: {
        name: "",
        status: "",
        readOnly: true,
      }
    };
  },
  async created() {
    this.$store.commit("CHANGE_SECTION", { name: "Recordatorios", index: "4" });

    this.loading = true;
    await this.$store.dispatch("getReminders");
    this.loading = false;
  },
  methods: {
    hasPermission( permissionReq ) {
      return this.$store.getters.hasPermission('Reminders', permissionReq)
    },
    msgSuccess(text){
      this.$message({
        type: "success",
        message: text
      });
    },
    msgError(text) {
      this.$message({
        type: "error",
        showClose: true,
        duration: 0,
        message: text
      });
    },
    filterTrashType( value, row ) {
      if( row.trash_type === value )
        return true
      else if( !this.$store.state.orders.options.find(element => element.value == row.trash_type ) && value === 'others' )
        return true
      else
        return false
    },
    handleDelete(row) {
      this.$confirm(
        "Estás por borrar completamente el recordatorio de " + row.client_name,
        "Borrar",
        {
          confirmButtonText: "Borrar",
          cancelButtonText: "Cancelar",
          type: "warning"
        }
      )
      .then(() => {
        this.$store.dispatch("deleteReminder", row)
        .then(() => {
          this.msgSuccess("El recordatorio fue eliminado")
        })
        .catch(() => {
          this.msgError("Error eliminando el recordatorio")
        })
      })
      .catch(() => {})
    },
    handleDownload() {
      this.loadingExportButton = true;
      import("@/vendor/Export2Excel").then(excel => {
        const tHeader = [
          "Fecha",
          "Apellido y Nombre",
          "Razón Social",
          "Tipo de Residuo"
        ];
        const filterVal = [
          "date_text",
          "client_name",
          "client_business",
          "trash_type_t"
        ];
        const data = this.formatJson(filterVal);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "recordatorios"
        });
        this.loadingExportButton = false;
      });
    },
    formatJson(filterVal) {
      // Export only visible elements, if use filter, only export filtered elements
      return this.$refs.reminderListFiltered.tableData.map(v =>
        filterVal.map(j => {
          return v[j];
        })
      );
    }
  },
  computed: {
    searchInLowerCase() {
      return this.search.toLowerCase().trim();
    },
    is_mobile() {
      return this.$store.state.is_mobile;
    },
    reminderList() {
      return this.$store.state.reminders.list;
    },
    options() {
      let options = []
      this.$store.state.orders.options.forEach( e => {
        options.push({text: e.label, value: e.value})
      })
      options.push({text: 'Otros', value: 'others'})

      // Order by name
      options.sort(function(a, b) {
        var nameA = a.text.toUpperCase(); // ignore upper and lowercase
        var nameB = b.text.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        // names must be equal
        return 0;
      });
      return options
    },
  }
};
</script>